<template>
   <div class="search">
     <div class="head">
       <div class="flex">
         <div class="icon1"></div>
         <div class="school" >
           <span @click="choose">{{adminName}}</span>
           <span v-if="role==1">-</span>
           <span v-if="role==1" @click="choose1">{{schoolName}}</span>
           <span v-if="role==0" @click="choose">{{schoolName}}</span>
         </div>
         <div class="icon2" @click="choose"></div>
       </div>
     </div>
     <div class="box special">
       <div class="title special">
         <div>
           <input placeholder="开始日期" type="date" @input="choosestart1" v-model="start_time1"/> —
           <input placeholder="结束日期" type="date" @input="chooseend1" v-model="end_time1"/>
         </div>
<!--         <div class="find" @click="search">搜索</div>-->
       </div>
     </div>
     <div class="box">
       <div class="title">
         <div>
           <div class="icon3"></div>
           <div class="txt">数据概览</div>
         </div>
       </div>
       <div class="option">
         <div class="item">
           <div>新客购买人数</div>
           <div class="num">{{overView.new_buy}}</div>
         </div>
         <div class="item">
           <div>新客购买金额</div>
           <div class="num">￥{{overView.new_order_amount}}</div>
         </div>
       </div>
       <div class="option">
         <div class="item">
           <div>老客购买人数</div>
           <div class="num">{{overView.old_buy}}</div>
         </div>
         <div class="item">
           <div>老客购买金额</div>
           <div class="num">￥{{overView.old_order_amount}}</div>
         </div>
         <div class="item">
           <div>老客复购率</div>
           <div class="num">{{overView.old_buy_again}}</div>
         </div>
       </div>
     </div>
     <div class="box3">
       <div class="title">
         <div>
           <div class="icon3"></div>
           <div class="txt">胶囊口味销售占比</div>
         </div>
       </div>
       <div class="content">
         <div id="main"  class="main" style="width:100%;height:200px;"></div>
         <div class="flex-box special" v-if="!none1">
           <div class="first">排名</div>
           <div class="second">咖啡名称</div>
           <div class="third">购买人数</div>
           <div class="third">购买金额</div>
         </div>
         <div class="flex-box" v-for="(item,index) in tablelist">
           <div class="first">{{index+1}}</div>
           <div class="second">{{item.goods_name}}</div>
           <div class="third">{{item.user_count}}</div>
           <div class="third">￥{{item.goods_price}}</div>
         </div>
         <div class="flex-box" v-if="!none1">
           <div class="first"></div>
           <div class="second">汇总：</div>
           <div class="third">{{total1}}</div>
           <div class="third">{{total2}}</div>
         </div>
       </div>
     </div>

     <div class="box3">
       <div class="title">
         <div>
           <div class="icon3"></div>
           <div class="txt">机器销售占比</div>
         </div>
       </div>
       <div class="content">
         <div id="main2"  class="main" style="width:100%;height:200px;"></div>
         <div class="flex-box special" v-if="!none2">
           <div class="first">排名</div>
           <div class="second">咖啡名称</div>
           <div class="third">购买人数</div>
           <div class="third">购买金额</div>
         </div>
         <div class="flex-box" v-for="(item,index) in tablelist2">
           <div class="first">{{index+1}}</div>
           <div class="second">{{item.goods_name}}</div>
           <div class="third">{{item.user_count}}</div>
           <div class="third">￥{{item.goods_price}}</div>
         </div>
         <div class="flex-box" v-if="!none2">
           <div class="first"></div>
           <div class="second">汇总：</div>
           <div class="third">{{total3}}</div>
           <div class="third">{{total4}}</div>
         </div>
       </div>
     </div>


     <div class="foot" v-if="!isShow">
       <div class="tabs" @click="link(1)">
         <div class="tab tab1"></div>
         <div class="txt">首页</div>
       </div>
       <div class="tabs on" @click="link(2)">
         <div class="tab tab2"></div>
         <div class="txt">业绩查询</div>
       </div>
       <div  class="tabs" @click="link(3)">
         <div class="tab tab3"></div>
         <div class="txt">我的二维码</div>
       </div>
     </div>
     <div class="foot special" v-if="isShow">
       <div class="tabs" @click="link(1)">
         <div class="tab tab1"></div>
         <div class="txt">首页</div>
       </div>
       <div class="tabs on" @click="link(2)">
         <div class="tab tab2"></div>
         <div class="txt">业绩查询</div>
       </div>
     </div>
     <div class="dialog" v-if="role==0" :class="show">
       <div class="fixed"></div>
       <div class="blank">
         <div class="close" @click="close"></div>
         <div class="list">
           <div class="li" :class="item.is_active==true?'':'on'" v-for="(item,index) in schools" @click="chooseSchool(index,schools)">
             <div class="choose"></div>
             <div>{{item.school_name}}</div>
           </div>
         </div>
       </div>
     </div>
     <div class="picker" v-if="role==1" :class="show">
       <van-picker  show-toolbar title="" :columns="columns" @cancel="cancel" @change="change" @confirm="confirm"/>
       <div class="fixed" ></div>
     </div>
     <div class="picker" v-if="role==1" :class="show2">
       <van-picker  show-toolbar title="" :columns="columns1" @cancel="cancel1" @change="change1" @confirm="confirm1"/>
       <div class="fixed" ></div>
     </div>
   </div>
</template>

<script>
    import detail from '@/components/detail'
    let school_id
    let role
    let link='http://ap.bjcreate.net/school/'
    let openid
    let start_time
    let end_time
    let qrcode_id
    let index_left=0
    let index_right=0
    export default {
        name: "search",
        data () {
          return{
            value1:'',
            show:'',
            overView:{},
            tablelist:[],
            tablelist2:[],
            list:[],
            arr:[],
            machine:[],
            arr2:[],
            schools:[],
            schoolName:"",
            none1:false,
            none2:false,
            isShow:false,
            role:0,
            start_time1:'',
            end_time1:'',
            adminName:'',
            show2:'',
            columns1: [
              {

              },
            ],
            columns: [
              {

              },
            ],
            total1:0,
            total2:0,
            total3:0,
            total4:0,
          }
        },
       mounted() {
          //this.draw()
         school_id=this.$route.query.school_id
         openid=this.$route.query.openid
         start_time= this.getday(-6)
         end_time= this.getday(0)
         this.start_time1= this.getday(-6)
         this.end_time1= this.getday(0)
         this.value1=[start_time,end_time]
         role=this.$route.query.role
         this.role=role
         qrcode_id=this.$route.query.qrcode_id
         if(role==1){
           this.isShow=true
         }else{
           this.isShow=false
         }
         this.ismember()

       },
      created() {




      },
      methods:{
          ismember(){
          this.$axios.post(link+'api/school/isbind',
            {openid:openid}
          ).then(res=>{
            console.log(res.data)
            if(res.data.Code==200){
              if(role==1){
                this.getambassador()
              }else{
                this.getschools()
              }

            }else{
              //window.location.href='http://ap.bjcreate.net/school/school/Login/Index'
            }

          }).catch(error=>{
            console.log(error)
          })
        },
          //学校列表
          getschools(){
          this.$axios.post(link+'api/school/getschoollist',
            {openid:openid}
          ).then(res=>{
            console.log(res.data)
            res.data.ResultData[0].is_active=false
            this.schools=res.data.ResultData
            this.schoolName=res.data.ResultData[0].school_name
            school_id=res.data.ResultData[0].school_id
            //销售总额 数据概况
            //数据概况
            this.getdataview(school_id)
            this.salesper(school_id)
            this.machinesper(school_id)

          }).catch(error=>{
            console.log(error)
          })
        },
          //数据概况
          getdataview(){
          this.$axios.post(link+'api/school/performancedatabrief',
            {
              openid:openid,
              school_id:school_id,
              start_time:start_time,
              end_time:end_time
            }
          ).then(res=>{
            console.log(res.data)
            if(res.data.Code==200){
              this.overView=res.data.ResultData
            }


          }).catch(error=>{
            console.log(error)
          })
        },
          //胶囊占比getcapsuleamount
          salesper(){
            this.$axios.post(link+'api/school/getcapsuleamount',
              {
                openid:openid,
                school_id:school_id,
                start_time:start_time,
                end_time:end_time
              }
            ).then(res=>{
              console.log(res.data)
              this.list=[]
              this.arr=[]
              this.tablelist=res.data.ResultData
              if(res.data.ResultData.length>0){
                res.data.ResultData.forEach(value=>{
                  this.none1=false
                  this.total1+=value.user_count
                  this.total2+=value.goods_price
                 // menus.list.push({class:'',name:categories[0].name, order:categories[0].order,goods:[]})
                  this.list.push({name:value.goods_name,value:value.user_count})
                  this.arr.push(value.goods_name)
                  console.log(this.list)
                  console.log(this.arr)
                  this.draw(this.arr,this.list)
                })
              }else{
                this.none1=true
                this.draw(this.arr,this.list)
                document.getElementById('main').innerHTML = '暂无数据'
              }


            }).catch(error=>{
              console.log(error)
            })
          },
          //机器占比getcapsuleamount
          machinesper(){
            this.$axios.post(link+'api/school/getmachineamount',
              {
                openid:openid,
                school_id:school_id,
                start_time:start_time,
                end_time:end_time
              }
            ).then(res=>{
              console.log(res.data)
              this.machine=[]
              this.arr2=[]
              this.tablelist2=res.data.ResultData
              if(res.data.ResultData.length>0){
                res.data.ResultData.forEach(value=>{
                  this.total3+=value.user_count
                  this.total4+=value.goods_price
                  // menus.list.push({class:'',name:categories[0].name, order:categories[0].order,goods:[]})
                  this.none2=false
                  this.machine.push({name:value.goods_name,value:value.user_count})
                  this.arr2.push(value.goods_name)
                  console.log(this.list)
                  console.log(this.arr)
                  this.draw2(this.arr2,this.machine)
                })
              }else{
                this.none2=true
                this.draw2(this.arr,this.list)
                document.getElementById('main2').innerHTML = '暂无数据'
              }


            }).catch(error=>{
              console.log(error)
            })
          },


          getambassador(){
          this.$axios.post(link+'api/school/adminambassador',
            {
              openid:openid,
            }
          ).then(res=>{
            console.log(res.data)
            this.columns=[]
            res.data.ResultData.forEach(value=>{
              this.columns.push({text:value.real_name})
              if(value.qrcode_id==qrcode_id){
                this.adminName=value.real_name
              }

            })
            this.ambassador=res.data.ResultData

           // this.adminName=this.ambassador[0].real_name
            qrcode_id=this.ambassador[0].qrcode_id
            this.getadminschools()



          }).catch(error=>{
            console.log(error)
          })
        },
          getadminschools(index){
          this.$axios.post(link+'api/school/schoollist',
            {
              openid:openid,
              qrcode_id:qrcode_id
            }
          ).then(res=>{
            console.log(res.data)
            res.data.ResultData[0].is_active=false
            this.columns1=[]
            res.data.ResultData.forEach(value=>{
              this.columns1.push({text:value.school_name})
              if(index==0){
                this.schoolName=res.data.ResultData[0].school_name
                school_id=res.data.ResultData[0].school_id
              }else{
                if(school_id==value.school_id){
                  this.schoolName=value.school_name
                }
              }


            })

            this.schools=res.data.ResultData
            //销售总额 数据概况
            //数据概况
            this.getadmindataview(school_id)
            this.adminsalesper(school_id)
            this.adminmachinesper(school_id)

          }).catch(error=>{
            console.log(error)
          })
        },
          getadmindataview(){
            this.$axios.post(link+'api/school/adminperformancedatabrief',
              {
                openid:openid,
                school_id:school_id,
                start_time:start_time,
                end_time:end_time,
                qrcode_id:qrcode_id
              }
            ).then(res=>{
              console.log(res.data)
              if(res.data.Code==200){
                this.overView=res.data.ResultData
              }


            }).catch(error=>{
              console.log(error)
            })
          },
          adminsalesper(){
          this.$axios.post(link+'api/school/getadmincapsuleamount',
            {
              openid:openid,
              school_id:school_id,
              start_time:start_time,
              end_time:end_time,
              qrcode_id:qrcode_id
            }
          ).then(res=>{
            console.log(res.data)
            this.list=[]
            this.arr=[]
            this.tablelist=res.data.ResultData
            if(res.data.ResultData.length>0){
              res.data.ResultData.forEach(value=>{
                this.none1=false
                this.total1+=value.user_count
                this.total2+=value.goods_price
                // menus.list.push({class:'',name:categories[0].name, order:categories[0].order,goods:[]})
                this.list.push({name:value.goods_name,value:value.user_count})
                this.arr.push(value.goods_name)
                console.log(this.list)
                console.log(this.arr)
                this.draw(this.arr,this.list)
                this.none1=false
              })
            }else{
              this.none1=true
              this.draw(this.arr,this.list)
              document.getElementById('main').innerHTML = '暂无数据'
            }


          }).catch(error=>{
            console.log(error)
          })
        },
          adminmachinesper(){
          this.$axios.post(link+'api/school/getadminmachineamount',
            {
              openid:openid,
              school_id:school_id,
              start_time:start_time,
              end_time:end_time,
              qrcode_id:qrcode_id
            }
          ).then(res=>{
            console.log(res.data)
            this.machine=[]
            this.arr2=[]
            this.tablelist2=res.data.ResultData
            if(res.data.ResultData.length>0){
              res.data.ResultData.forEach(value=>{
                this.total3+=value.user_count
                this.total4+=value.goods_price
                // menus.list.push({class:'',name:categories[0].name, order:categories[0].order,goods:[]})
                this.none2=false
                this.machine.push({name:value.goods_name,value:value.user_count})
                this.arr2.push(value.goods_name)
                console.log(this.list)
                console.log(this.arr)
                this.draw2(this.arr2,this.machine)
              })
            }else{
              this.none2=true
              this.draw2(this.arr,this.list)
              document.getElementById('main2').innerHTML = '暂无数据'
            }


          }).catch(error=>{
            console.log(error)
          })
        },

          choosestart1(e){
          this.start_time1=e.target.value
          if(role==1){
            this.getadmindataview()
            this.adminsalesper()
            this.adminmachinesper()
          }else{
            this.getdataview()
            this.salesper()
            this.machinesper()
          }
        },
          chooseend1(e){
          this.end_time1=e.target.value
          if(role==1){
            this.getadmindataview()
            this.adminsalesper()
            this.adminmachinesper()
          }else{
            this.getdataview()
            this.salesper()
            this.machinesper()
          }
        },
          //搜索
          search(){
            //数据概况
            if(role==1){
              this.getadmindataview()
              this.adminsalesper()
              this.adminmachinesper()
            }else{
              this.getdataview()
              this.salesper()
              this.machinesper()
            }

          },
          choosetime:function(e){
            console.log(e)
            start_time=e[0]
            end_time=e[1]
          },
          chooseSchool(index,schools){
            console.log(index)
            console.log(schools)
            schools.forEach(value=>{
              value.is_active=true
            })
            schools[index].is_active=!schools[index].is_active
            this.schools=schools
            this.schoolName=schools[index].school_name
            school_id=schools[index].school_id
            this.show=''
            //数据概况
            if(role==1){
              this.getadmindataview(school_id)
              this.getadmindataview(school_id)
              this.adminsalesper(school_id)
            }else{
              this.getdataview(school_id)
              this.getdataview(school_id)
              this.salesper(school_id)
            }


        },
          choose(){
            this.show='on'
          },
          choose1(){
            this.show2='on'
          },
          draw(arr,list){
            let option
            option =  {

              tooltip: {
                trigger: 'item',
                formatter: function (params) {
                  let str = params.name;
                  console.log(params);
                  console.log(1111111);
                  let arr = str.split('');
                  for (let j = 9; j < arr.length; j += 10) //超过13个字换行
                  {
                    if (isNaN(arr[j]) == true && arr[j] != '.') { //如果是数字和小数点就不换行

                      arr[j] += '</br>';
                    } else {

                      arr[j] += '';
                    }
                  }
                  str = arr.join("")
                  return str + "<br/> " + params.value + " (" + params.percent + "%)";
                }



                // formatter:"{a}<br/>{b}:<br/> {c} ({d}%)"
              },
              legend: {
                show : true,
                orient: 'vertical',
                x: '140px',
                y:'40px',
                data:arr,
                formatter: function (name) {
                  console.log(name)
                  if(name && name.length > 15){
                    var str1 = name.substring(0, 15)
                    var str2 = name.substring(15)
                    name = str1 + "\n" + str2
                  }
                  return name;
                }
                /* itemWidth:10,
                 itemHeight:10*/
              },
              series: [
                {
                  type:'pie',
                  center: ['20%', '50%'],
                  radius: ['40%', '55%'],
                  avoidLabelOverlap: false,
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '12',
                        fontWeight: 'bold'
                      }
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data:list,
                  color: ['rgb(230,63,67)','rgb(255,143,88)','rgb(255,195,55)','rgb(196,153,111)']
                }
              ],
              textStyle:{
                fontSize:12


              }

            };

            let myChart = this.$echarts.init(document.getElementById('main'))

            myChart.setOption(option);
          },
          draw2(arr,list){
            let option2
            option2 =  {

              tooltip: {
                trigger: 'item',
                formatter: function (params) {
                  let str = params.name;
                  console.log(params);
                  let arr = str.split('');
                  for (let j = 9; j < arr.length; j += 10) //超过13个字换行
                  {
                    if (isNaN(arr[j]) == true && arr[j] != '.') { //如果是数字和小数点就不换行

                      arr[j] += '</br>';
                    } else {

                      arr[j] += '';
                    }
                  }
                  str = arr.join("")
                  return str + "<br/> " + params.value + " (" + params.percent + "%)";
                }



                // formatter:"{a}<br/>{b}:<br/> {c} ({d}%)"
              },
              legend: {
                show : true,
                orient: 'vertical',
                x: '140px',
                y:'40px',
                data:arr,
                formatter: function (name) {
                  if(name && name.length > 15){
                    var str1 = name.substring(0, 15)
                    var str2 = name.substring(15)
                    name = str1 + "\n" + str2
                  }
                  return name;
                }
                /* itemWidth:10,
                 itemHeight:10*/
              },
              series: [
                {
                  type:'pie',
                  center: ['20%', '50%'],
                  radius: ['40%', '55%'],
                  avoidLabelOverlap: false,
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '12',
                        fontWeight: 'bold'
                      }
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data:list,
                  color: ['rgb(230,63,67)','rgb(255,143,88)','rgb(255,195,55)','rgb(196,153,111)']
                }
              ],
              textStyle:{
                fontSize:12


              }

            };

            let myChart2 = this.$echarts.init(document.getElementById('main2'))
            console.log(myChart2)
            myChart2.setOption(option2);
          },
          close(){
            this.show=''
          },
          detail(){
           this.$router.push({
             path:'detail'
             //path:'detail?id='+item.id
             //name:`detail`,query:{id:item.id}
           })
         },
          link(e){
          console.log(e)
          if(e==1){
            this.$router.push({
              path:'/?o='+openid+'&r='+role
            })
          }else if(e==2){

          }
        },
          //获取最近七天
          getday(day){
            var today = new Date();
            var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            return tYear+"-"+tMonth+"-"+tDate;
          },
          doHandleMonth(month){
            var m = month;
            if(month.toString().length == 1){
              m = "0" + month;
            }
            return m;
          },
          cancel(e){
            this.show=''
          },
          change(e){
            console.log(e)
            index_left=e.children[0].currentIndex
            //index_right=e.children[1].currentIndex
          },
          confirm(e){
            console.log(e)
            this.show=''
            qrcode_id=this.ambassador[index_left].qrcode_id
            this.adminName=this.ambassador[index_left].real_name
            this.getadminschools(0)
          },
          cancel1(e){
            this.show2=''
          },
          change1(e){
            //index_left=e.children[0].currentIndex
            index_right=e.children[0].currentIndex
          },
          confirm1(e){
            this.show2=''
            school_id=this.schools[index_right].school_id
            this.schoolName=this.schools[index_right].school_name
            //this.getadminschools(qrcode_id,index_right)
            this.getadmindataview(school_id)
            this.adminsalesper(school_id)
            this.adminmachinesper(school_id)
          },
        },
        components:{
          detail
        }
    }
</script>

<style scoped>
  .school{
    max-width:5rem;
  }
  .picker{
    width:100%;
    position: fixed;
    left:0;
    bottom:0;
    z-index: 50;
    visibility: hidden;
    -webkit-transition: visibility 0.5s 0s;
    transition: visibility 0.5s 0s;
  }
  .picker.on{
    visibility:visible;transition: visibility 0.5s 0s;
  }
  .van-picker{
    z-index:20;
    width:100%;
    opacity: 0;
    -webkit-transition: opacity 0.5s 0s;
    transition: opacity 0.5s 0s;
  }
  .picker.on .van-picker{
    opacity: 1;
    visibility:visible;transition: visibility 0.5s 0s;
  }

  .none{
    text-align: center;
    color:#666;
    font-size:0.3rem;
    padding:1rem 0;
  }
  .contains{
    padding-bottom:1.6rem;
  }
  .foot{
    position: fixed;
    width:100%;
    height:1.3rem;
    background-color:#fff;
    left:0;
    bottom:0;
    font-size:0.22rem;
    display: flex;
    align-items:flex-start;
    justify-content: space-between;
    padding-top:0.2rem;
    color:#A8A8A8;
    box-shadow:2px 0px 5px rgba(0,0,0,0.2);
  }
  .foot.special{
    justify-content: center;
  }
  .foot>.tabs{
    width:2.3rem;
    text-align: center;
  }
  .foot.special>.tabs{
    width:3.3rem;
    text-align: center;
  }
  .tab1{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon9.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab1{
    background: url(../assets/icon9-on.png) no-repeat center top;
    background-size: 100%;
  }
  .foot>.on .txt{
    color:#FF9831;
  }

  .tab2{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon10.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab2 {
    background: url(../assets/icon10-on.png) no-repeat center top;
    background-size: 100%;
  }
  .tab3{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon16.jpg) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab3{
    background: url(../assets/icon16-on.jpg) no-repeat center top;
    background-size: 100%;
  }
  a{
    text-decoration:none;
    outline: none;	/* 去除旧版浏览器的点击后的外虚线框 */
    color: #000;
  }
  .txt{
    color:#000;
  }
<!--  -->
  .box.special{
    margin:-0.5rem auto 0.2rem;
    padding:0.2rem 0;
  }
  .el-date-editor--daterange.el-input__inner{
    width:280px;
    border:none;
    /*margin-left:0.2rem;*/
  }
  .find{
    width: 1.44rem;
    height: 0.56rem;
    line-height: 0.56rem;
    text-align: center;
    color: #fff;
    font-size: 0.22rem;
    background-color: #FF961E;
    border-radius: 25px;
  }

  /*表格*/
  .flex-box{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size:0.24rem;
    line-height:0.88rem;
    border-bottom:1px solid #eaeaea;
    color:#555555;
    padding:0 0.3rem;
  }
  .flex-box.special{
    color:#000;
    background-color:#FAFAFA;
  }
  .first{
    width:1.35rem;
  }
  .second{
    width:3.2rem;
    line-height: 0.35rem;
  }
  .third{
    width:1.6rem;
  }
  .fourth.special{
    color:#feac4e;
  }


  .search{
    background-color:#f2f2f2;
    padding-bottom: 1.6rem;
  }
  .head{
    width:100%;
    height:2rem;
    background-image: linear-gradient(#FEA827, #FF8636);
    overflow: hidden;
  }
  .flex{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size:0.38rem;
    color:#fff;
    margin-top:0.35rem;
  }
  .icon1{
    width:0.47rem;
    height:0.45rem;
    background: url(../assets/icon14.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.3rem;
    margin-left:0.38rem;
  }
  .icon2{
    width:0.26rem;
    height:0.26rem;
    background: url(../assets/icon6.png) no-repeat center top;
    background-size: 100%;
    margin-left:0.3rem;
  }
  .icon5{
    display: inline-block;
    width:0.28rem;
    height:0.29rem;
    background: url(../assets/icon5.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
    vertical-align: middle;
  }
  .box{
    width:7.3rem;
    /*min-height:3rem;*/
    margin:-0rem auto 0;
    border-radius:9px;
    background-color:#fff;
    padding-bottom:0.4rem;
    padding-top:0.2rem;
    overflow: hidden;
  }
  .box.special{
    border-radius:9px 9px 0 0;
    margin:-0.5rem auto 0;
  }
  .box3{
    width:7.3rem;
    min-height:3rem;
    margin:0.2rem auto 0;
    border-radius:9px;
    overflow: hidden;
  }
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height:0.8rem;
    font-size:0.32rem;
    background-color: #fff;
    max-width:6.8rem;
    margin:0 auto 0;
  }
  .title input{
    height:1rem;
    line-height:1rem;
    border:1px solid #ddd;
    background-color:#fff;
    padding-left:0.1rem;
    font-size:0.3rem;
    outline: none;
    -webkit-appearance:none;
  }
  .icon3{
    display: inline-block;
    width:0.33rem;
    height:0.29rem;
    background: url(../assets/icon4.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
    vertical-align: middle;
  }
  .txt{
    display: inline-block;
    vertical-align: middle;
  }
  .option{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top:0.5rem;
  }
  .item{
    flex:1;
    font-size:0.24rem;
    text-align:center;
    color:#333;
  }
  .item .num{
    color:#FF9831;
    font-size: 0.32rem;
    margin-top:0.2rem;
  }
  .content{
    /*margin-top:0.2rem;*/
    background-color:#fff;
  }
  .main{
    border-radius: 5px;
    text-align: center;
    line-height:3rem;
    color:#666;
    font-size:0.3rem;
  }

  /*选择学校*/
  .dialog{
    visibility:hidden;transition: visibility 0s 0.5s;
  }
  .dialog.on{
    visibility:visible;transition: visibility 0s 0s;
  }
  .fixed{
    position: fixed;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.6);
    z-index:10;
    left:0;
    top:0;
    opacity: 0;transition: opacity 0.5s 0s;
  }
  .on .fixed{
    opacity: 1;transition: opacity 0.5s 0s;
  }
  .blank{
    width:100%;
    background-color:#fff;
    position: fixed;
    left:0;
    top:-600px;
    z-index:20;
    min-height:5rem;
    transition: top 0.5s 0s;
  }
  .on .blank{
    top:-0px;
    transition: top 0.5s 0s;
  }
  .close{
    position: absolute;
    width:0.5rem;
    height:0.5rem;
    right:0.2rem;
    top:0.2rem;
    background: url(../assets/icon8.png) no-repeat center center;
    background-size: 50%;
  }
  .list{
    width:6.47rem;
    margin:0.5rem auto 0;
  }
  @keyframes donghua{
    0%{-webkit-transform: translateY(-600px);transform: translateY(-600px);}
    100%{-webkit-transform: translateY(0rem);transform: translateY(0rem);}
  }
  .list .li{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom:1px solid #DBDBDB;
    height:1rem;
    font-size:0.28rem;
  }
  .list .li .choose{
    width:0.22rem;
    height:0.22rem;
    border-radius:50%;
    margin-right:0.6rem;
    background: url(../assets/icon7.png) no-repeat center center;
    background-size: 100%;
  }
  .list .li.on .choose{
    background: url(../assets/icon7-on.png) no-repeat center center;
    background-size: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/search.vue